import TCFLabel from './TCFLabel'

export default TCFLabel
